import { getAddressFieldsDataView } from "@insite/client-framework/Store/Data/AddressFields/AddressFieldsSelector";
import {
    chain,
    DispatchCompleteUpdateShipTo,
} from "@insite/client-framework/Store/Pages/CheckoutShipping/Handlers/UpdateShipTo";
import validateShippingAddressForm from "@insite/client-framework/Store/Pages/CheckoutShipping/Handlers/ValidateShippingAddressForm";
import {
    addToChainBefore,
    createChainHandler,
    makeHandlerChainAwaitable,
} from "@toolkit/Modules/client-framework/HandlerCreator";

export const ValidateShippingAddress = createChainHandler("ValidateShippingAddress", chain, async props => {
    if (!props.apiResult.validation) {
        return;
    }

    const addressFieldsDataView = getAddressFieldsDataView(props.getState());
    const awaitableValidate = makeHandlerChainAwaitable<Parameters<typeof validateShippingAddressForm>[0], boolean>(
        validateShippingAddressForm,
    );

    const isShippingAddressValid = await awaitableValidate({
        address: props.apiResult,
        validation: props.apiResult.validation,
        fieldDisplay: addressFieldsDataView.value!.shipToAddressFields,
    })(props.dispatch, props.getState);

    props.dispatch({
        type: "Pages/CheckoutShipping/SetIsShippingAddressUpdateRequired",
        isShippingAddressUpdateRequired: !isShippingAddressValid,
    });
});

addToChainBefore(chain, DispatchCompleteUpdateShipTo, ValidateShippingAddress);
